import React from 'react';
import Dialog from 'material-ui/Dialog';
import SnapshotForm from './SnapshotForm';
import Aox from '../hoc/Aox';

export default class ModalSnapshot extends React.Component {
  render() {
    return (
      <Aox>
        <span className="btn--open-snapshot-modal" onClick={() => this.props.handleSnapshotActivated()}>
          <span className="icon" />
        </span>

        <Dialog
          modal={ false }
          open={ this.props.isModalOpen }
          bodyStyle={{ 
            margin: '10px',
          }}
          style={{
            paddingTop: '10px',
          }}
          className="modal modal--snapshot"
        >
          <div className="modal-content">
            <div className="snapshot-image">
              <img src={`data:image/png;${this.props.tempSnapshotUrl}`} alt="" width="400px" height="275px" /> 
            </div>
            <div className="grey-wrapper snapshot-note-container">
              <h3>add note for image</h3>
              <SnapshotForm
                handleSnapshotSaved={this.props.handleSnapshotSaved}
                cancelSnapshot={this.props.cancelSnapshot}
              />
            </div>
          </div>
        </Dialog>
      </Aox>
    );
  }
}